module.exports = __webpack_public_path__ + "static/dhec-3a747489d4df06fabe240a4110e8b3a8.jpg";